import React from 'react'
import cx from 'classnames'

import styles from './CategoriesMenu.module.scss'

const CategoriesMenuLink = ({ slug, href, children }) => {
  const url = window.location.href
  const regex = new RegExp(`\\b${slug}\\b`)
  const selected = regex.test(url)

  return (
    <li>
      <a href={href} className={cx(styles.categoriesMenuLink, { [styles.selected]: selected })}>
        {children}
      </a>
    </li>
  )
}

export default CategoriesMenuLink
